import React from 'react'
import { Icons } from '../../assets'
import classes from "./style.module.scss"

const SearchInput= ({placeholder, onChange, width}) => {
  return (
    <div className={`${classes.input} flex h-[48px] items-center gap-1`} style={{width}}>
        <img src={Icons.searchIcon} className='w-[24px] h-[24px]'/>
        <input type='text' placeholder={placeholder} onChange={onChange} className={`${classes.inputField} w-[100%]`}/>
    </div>
  )
}

export default SearchInput
